import styled from 'styled-components'

export const Label = styled.p`
  font-size: 2rem;
  font-weight: bold;
  color: var(--azul-escuro);
  margin-top: 2rem;
  margin-bottom: 1rem;
`
export const ImageDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
`

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2rem;
  padding-bottom: 8rem;
`
export const Input = styled.input`
  width: 80%;
  height: 2rem;
  padding-left: 0.5rem;
`
export const IconDiv = styled.div`
  height: auto;
  border: 1px solid gray;
  border-radius: 50%;
`
export const Image = styled.img`
  width: 12rem;
  height: 12rem;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 1rem;
  border: 1px solid gray;
`
export const Field = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  align-self: center;
`
export const PasswordDiv = styled.div`
  width: 85%;
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
  gap: 1.5rem;
`
export const PhotoSend = styled.label`
  input[type='file'] {
    display: none;
  }
  color: var(--azul-escuro);
  display: flex;
  justify-content: center;
  padding: 6px 12px;
  font-size: 1.2rem;
  cursor: pointer;
  font-weight: bold;
  gap: 0.5rem;
`
